export const logInAction = () => {
  return new Promise<{ token: string }>((resolve) =>
    setTimeout(() => {
      resolve({
        token: '123456789',
      });
    }, 1000),
  );
};
